// extracted by mini-css-extract-plugin
export default {"container":"Simple_container__ntpYl","gridContainerSingleRowLayoutSpaced":"Simple_gridContainerSingleRowLayoutSpaced__PpcLk"};